import { groq } from 'next-sanity';
import { z } from 'zod';

import { link, SanityLink } from './link';

/**
 * A single button inside a button row (Sanity `cardButton` object). The link
 * fields are spread in from the first `link` entry, so they're optional until
 * an editor sets a destination.
 */
export const SanityCardButton = SanityLink.partial().extend({
  _key: z.string().optional().nullable(),
  style: z.enum(['primary', 'outline', 'arrow']),
});
export type SanityCardButton = z.infer<typeof SanityCardButton>;

export const SanityButtonRow = z.array(SanityCardButton);
export type SanityButtonRow = z.infer<typeof SanityButtonRow>;

export const cardButton = groq`{
  _key,
  style,
  ...(link[0] ${link}),
}`;
